import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/suggestion.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleSuggestionCancelledEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: ArticleSuggestionCancelledEvent
}

const ArticleSuggestionCancelled = ({ event, ...props }: Props) => {
  const {
    user,
    article,
    data: { branch, base_branch },
  } = event
  const isBaseBranch = base_branch.key === article.key

  const content = isBaseBranch ? (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user.id} /> ended the suggestions merge request
      on this linked copy: {branch.title}
    </>
  ) : (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user.id} /> ended the suggestions merge request
    </>
  )

  return <BaseActivityEvent {...props} icon={<Icon />} timestamp={event.timestamp} content={content} />
}

export { ArticleSuggestionCancelled }
